import template from './progressbar.template.html';

/* @ngInject */

export default () => {
  return {
    template,
    restrict: 'E',
    scope: {
      size: '='
    },
    link: function (scope, element) {
      var margin = (element.parent().height() - scope.size) / 2;
      element.css('margin-top', margin + 'px');
    }
  };
};
